// extracted by mini-css-extract-plugin
export default {"social-media-form__icon":"social-media-form__icon--3dFwH"};
    if(module.hot) {
      // 1747648157077
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  